import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import List from '@material-ui/core/List';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import { setFocusElement, toggleRightDrawer, setTabOnFocus, setCurrentViewId, setReRender, setTestcaseToCopy, toggleBottomDrawer, updateAiAssistant, setLogHelper } from '../../store/global/actions';
import { getBottomDrawerStatus, getElementOnFocus, getRightDrawerStatus, getTestcaseToCopy } from '../../store/global/selectors';
import { getViewId, getReRender, getInnerScreenRender, getCodeEditStatus } from '../../store/global/selectors';
import { setSelectedTransactionId } from '../../store/global/actions';
import { reRenderInfoBuilder, setNodeClicked, setIsDocumentClicked } from '../../store/global/actions';
import { constructIds } from '../../config/common';
import { handleSnackBar } from '../../store/global/actions';
import ClusterletsConfiguration from '../../components/molecules/dashboardBuilder/ClusterletsConfig';
import Requester from '../../store/blueprint/svc';
import { invokePostService, invokeGetService } from '../../store/global/actions';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Menu, MenuItem } from '@material-ui/core';
import DeleteSimulationTestsuiteAlert from '../../components/molecules/alerts/DeleteSimulationTestsuiteAlert';
import { getDetailsFromUrl } from '../../services/blueprint';
import TransactionDialog from '../../components/molecules/alerts/CreateTransactionAlert';
import { getViews } from '../../store/views/selectors';
import ViewForm from '../../components/molecules/dashboardBuilder/ViewForm';
import { UtilityFunctionDialog } from '../../components/molecules/utility_functions/UtilityFunctionDialog';
import { getOwnershipStatus } from '../../utils/llmUtils';

const fetch = new Requester();

const drawerWidth = 171;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#48566a',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    backgroundColor: '#48566a',
  },
  drawerPaper: {
    overflow: 'hidden',
    width: drawerWidth,
    marginLeft: '64px',
    backgroundColor: '#48566a',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
    marginTop: '50%',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  expandIcon: {
    position: 'absolute',
    top: '50%',
    right: 0,
    transform: 'translateY(-50%)',
    backgroundColor: '#fff',
    width: 24,
    height: 24,
    zIndex: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#000',
    borderRadius: '50%',
  },
  drawerCollapse: {
    marginLeft: '60px',
    backgroundColor: '#48566a',
    width: (drawerWidth * 1) / 100,
  },
  collapseMainDrawer: {
    width: 0,
    flexShrink: 0,
  },
  labels: {
    fontFamily: 'OpenSans-Semibold',
  },
  myTopography: {
    color: `rgba(${theme.palette.primary.main}, 0.5)`,
  },
  listHeaderIcon: {
    color: '#ffff00',
    cursor: 'pointer',
  },
  listHeader: {
    padding: '5px 0',
    background: '#3c4756',
    borderTop: '1px solid #817b7b',
  },
  myListItem: {
    paddingTop: 0.5,
    paddingBottom: 0.5,
    position: 'relative',
    transition: 'all 0.5s ease',
    paddingLeft: '5px',
    paddingRight: '5px',
    '&:hover': {
      background: '#323c4a',
    },
  },
  sidebarTopContent: {
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0.3em',
      height: '0.3em',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: '5px',
    },
    transition: 'height 0.5s ease-in-out',
  },
  sidebarContent: {
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0.3em',
      height: '0.3em',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: '5px',
    },
    // maxHeight: '43vh'
    transition: 'height 0.5s ease',
  },
  listCollapsed: {
    transition: 'height 0.5s ease-in-out',
    maxHeight: 32,
  },
  listItemsContainer: {
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0.3em',
      height: '0.3em',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: '5px',
    },
    transition: 'height 0.5s ease',
  },
  sidebarListContainer: {
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0.3em',
      height: '0.3em',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: '5px',
    },
    transition: 'height 0.5s ease',
  },
  tooltipActive: {
    background: '#737373',
  },
  tooltipInactive: {
    background: 'transparent',
  },
  menuPositionContainer: {
    position: 'absolute',
    right: 0,
    top: '0',
    pointerEvents: 'none',
  },
  simulationMenuContainer: {
    '& .MuiList-padding': {
      padding: 0,
    },
    '& .MuiPaper-rounded': {
      borderRadius: 0,
      background: '#48566a',
      color: '#fff',
      minWidth: '5rem',
      maxWidth: '9rem',
    },
  },
  testsuiteMenuItem: {
    '&:hover': {
      background: '#e9e8e8',
    },
  },
}));

export default function SideBar({ drawerOpen, toggleSideDrawer }) {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const { entityId, screen } = getDetailsFromUrl();

  let selectedIndex = 0;
  let maxStringLength = 12;

  const currentUrl = window.location.href;

  const codeEditStatus = useSelector(getCodeEditStatus);
  const testcaseToCopy = useSelector(getTestcaseToCopy);
  const isBottomDrawerOpen = useSelector(getBottomDrawerStatus);
  const elementOnFocus = useSelector(getElementOnFocus);
  const viewsData = useSelector(getViews);

  const [selectedView, setSelectedView] = useState(null);
  const [openClusterletConfig, setOpenClusterletConfig] = useState(false);
  const [collapseTransaction, setCollpaseTransaction] = useState(true);
  const [collapseDelegates, setCollapseDelegates] = useState(true);
  const [collapseSimulations, setCollapseSimulations] = useState(true);
  const [collapseUtilityFunctions, setCollapseUtilityFunctions] = useState(true);
  const [collapseClusterlets, setCollapseClusterlets] = useState(true);
  const [collapseView, setCollpaseView] = useState(true);
  const [selectedDelegate, setSelectedDelegate] = useState(null);
  const [selectedClusterlet, setSelectedClusterlet] = useState(null);
  const [selectedUtilityFunction, setSelectedUtilityFunction] = useState(null);
  const [tooltipActive, setTooltipActive] = useState('');
  const [transactionList, setTransactionList] = useState([]);
  const [clusterlets, setClusterlets] = useState([]);
  const [utilityFunctions, setUtilityFunctions] = useState([]);
  const [views, setViews] = useState([]);
  const [delegates, setDelegates] = useState([]);
  const [testsuites, setTestsuites] = useState([]);
  const rightDrawerStatus = useSelector(getRightDrawerStatus);
  const reRender = useSelector(getReRender);
  const innerScreenRender = useSelector(getInnerScreenRender);
  const currentView = useSelector(getViewId);
  const [loading, setLoading] = useState(true);
  const [selectedTestsuite, setSelectedTestsuite] = useState(null);
  const [testsuiteActiveMenu, setTestsuiteActiveMenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showDeleteTestsuite, setShowDeleteTestsuite] = useState(false);
  const [testcases, setTestcases] = useState([]);
  const [openAddTransactionDialog, setOpenAddTransactionDialog] = useState(false);
  const [openViewsDialog, setViewDialog] = useState(false)
  const [openUtilityFunctionDialog, setOpenUtilityFunctionDialog] = useState(false);

  // Simulation menu toggle handler

  const [open, setOpen] = React.useState(true);
  let [, , slug, id, tag, transaction] = history.location.pathname.split('/');

  // To check any view marked as default view in the list
  const checkDefaultViewInViewList = (views) => {
    try {
      const defaultView = views.find(item => item?.default === true);
      if (defaultView) {
        localStorage.setItem('DISABLE_DEFAULTVIEW_ALERT', 'true');
      }
    } catch (error) {
      console.error(`Checking default view failed. ${error.message}`);
    }
  }

  const currentTag = tag;
  const selectedId = transaction;
  useEffect(() => {

  }, [selectedTestsuite])

  useEffect(() => {
    setSelectedView(currentView);
    if (!rightDrawerStatus) {
      setSelectedDelegate(null);
      setSelectedClusterlet(null);
    }
  }, [views, rightDrawerStatus]);

  useEffect(() => {
    if (viewsData && views?.length > 0) {
      setViews(prev => {
        prev.forEach(view => {
          if (viewsData._id === view._id) {
            view.name = viewsData.name
          }
        })

        return prev
      })
    }
  }, [viewsData])

  useEffect(() => {
    dispatch(invokeGetService('getBlueprintConstructs', {})).then((response) => {
      if (response?.status === true) {
        const { transactions, handlers, events, messages, clusterlets } = response.data;

        const sortedTransactions = response?.data?.transactions.filter((t) => t?.type == 7).sort((a, b) => a?.order - b?.order);
        const sortedViews = response?.data?.views.sort((a, b) => a?.order - b?.order);

        
        const sortedDelegates = response?.data?.clusterlets
          ?.filter((item) => !item.hasOwnProperty('subType') && item.type === 1)
          ?.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });
        const sortedClusterlets = response?.data?.clusterlets
          ?.filter((item) => item.type === 2 || item.type === 3)
          ?.sort((a, b) => a?.order - b?.order);

        const testcases = response?.data?.testCases ? response?.data?.testCases : [];
        const sortedTestsuites = response?.data?.testSuites.sort((a, b) => a.order - b.order);


        const updatedTestsuites = sortedTestsuites.map(item => {
          const testsuite_testcases = testcases.filter(element => element.testsuite_id == item._id)?.sort((a, b) => a?.order - b?.order);

          item.testcase = testsuite_testcases && testsuite_testcases.length > 0 ? testsuite_testcases[0] : null;

          return item;

        })
        const sortedUtilityFunctions = response?.data?.utilityFunctions?.filter(item => item.name)?.sort((a, b) => a?.order - b?.order);
        
        setTransactionList(sortedTransactions);
        setViews(sortedViews);
        setTestcases(response?.data?.testCases ? response?.data?.testCases : []);
        checkDefaultViewInViewList(response?.data?.views);
        setTestsuites(updatedTestsuites != undefined ? updatedTestsuites : []);
        setClusterlets(sortedClusterlets);
        setDelegates(sortedDelegates);
        setUtilityFunctions(sortedUtilityFunctions);
        setLoading(false);

        const {
          handlerIdentifierMap, 
          clusterletNameMap, 
          clusterletMap, 
          transactionMap, 
          messageMap, 
          eventMap, 
          transactionNameMap,
          nestedTransactionMap,
          eventNameMap
        } = generateMaps({handlers, events, messages, transactions, clusterlets})

        dispatch(setLogHelper({
          handlerIdentifier: Object.fromEntries(handlerIdentifierMap),
          clusterletNameMap: Object.fromEntries(clusterletNameMap),
          clusterletMap: Object.fromEntries(clusterletMap),
          transactionEventMap: Object.fromEntries(transactionMap),
          messagesMap: Object.fromEntries(messageMap),
          eventMap: Object.fromEntries(eventMap),
          transactionNameMap: Object.fromEntries(transactionNameMap),
          nestedTransactionMap: Object.fromEntries(nestedTransactionMap),
          eventNameMap: Object.fromEntries(eventNameMap)
        }))
         
      }
    });

    handleExpandSidebarListByDefault()
  }, [reRender, innerScreenRender]);


  

  const generateMaps = ({handlers, events, messages, transactions, clusterlets}) => {
    const eventMap = new Map(events.map(event => [event._id, event]));
    const eventNameMap = new Map()
    const messageMap = new Map(messages.map(message => [message._id, message]));
    const transactionMap = new Map();
    const nestedTransactionMap = new Map();

    transactions.forEach(transaction => {
        for(let txn of transaction.nestedTransactions){
          nestedTransactionMap.set(txn.id, transaction)
        }
        for(let event of transaction.events){
            event.data = eventMap.get(event.id)
            transactionMap.set(event.id, transaction)
        }
    });
    
    for(let event of events){
      if(eventNameMap.has(event.name)){
        let groupedEvents = eventNameMap.get(event.name);
        groupedEvents.push(event)
      }else{
        eventNameMap.set(event.name, [event])
      }
    }
    
    const clusterletMap = new Map(clusterlets.map(clusterlet => [clusterlet._id, clusterlet]))
    const clusterletNameMap = new Map(clusterlets.map(clusterlet => [clusterlet.name, clusterlet]))
    const handlerIdentifierMap = new Map();
    const transactionNameMap = new Map(transactions.map(transaction => [transaction.name, transaction]))
    for(let handler of handlers){
        const event = eventMap.get(handler.event);
        const message = messageMap.get(event?.message);
        const transaction = transactionMap.get(event?._id);
        const source = clusterletMap.get(event?.src);
        const destination = clusterletMap.get(event?.dst)
        handlerIdentifierMap.set(`${handler.type}_${event?.name}_${message?.name}`, {
            transactionId: transaction?._id,
            eventId: event?._id,
            handler,
            source,
            destination
        })
    }
    return {handlerIdentifierMap, clusterletNameMap, clusterletMap, transactionMap, messageMap, eventMap, transactionNameMap, nestedTransactionMap, eventNameMap};
  }

  const isAIEntity = (provenance = {}) => {
    return provenance.createdBy === 'AI';
  };

  const getOwnershipSummary = ({
      transactions = [],
      views = [],
      clusterlets = [],
      simulations = [],
      delegates = []
  }) => {
      const entities = [
          ...transactions,
          ...views,
          ...clusterlets,
          ...simulations,
          ...delegates
      ];

      let aiCount = 0;
      let manualCount = 0;

      entities.forEach(entity => {
          if (isAIEntity(entity.provenance)) {
              aiCount++;
          } else {
              manualCount++;
          }
      });

      return {
          aiCount,
          manualCount,
          dominant: aiCount > manualCount ? 'AI' : manualCount > aiCount ? 'USER' : 'EQUAL'
      };
  }



  const handleExpandSidebarListByDefault = () => {

    if (screen === "testsuite") {
      setCollapseClusterlets(true)
      setCollapseDelegates(true)
      setCollpaseTransaction(true)
      setCollpaseView(true)
      setCollapseUtilityFunctions(true);
      setCollapseSimulations(false)

    } else if (screen === "view") {
      setCollapseClusterlets(true)
      setCollapseDelegates(true)
      setCollpaseTransaction(true)
      setCollpaseView(false)
      setCollapseSimulations(true)
      setCollapseUtilityFunctions(true);
    } else if (screen === "transaction") {
      setCollapseClusterlets(true)
      setCollapseDelegates(true)
      setCollpaseTransaction(false)
      setCollpaseView(true)
      setCollapseSimulations(true)
      setCollapseUtilityFunctions(true);
    } else if (screen === "utilityFunctions") {
      setCollapseClusterlets(true)
      setCollapseDelegates(true)
      setCollpaseTransaction(true)
      setCollpaseView(true)
      setCollapseSimulations(true)
      setCollapseUtilityFunctions(false);
    }
  }


  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(!open);
  };

  const handleCloseClusterletConfig = () => setOpenClusterletConfig(false);
  const handleCloseUtilityFunctonDialog = () => {
    setOpenUtilityFunctionDialog(false);
    setSelectedUtilityFunction(null);
  }


  const createTransaction = () => {
    if (codeEditStatus) {
      // For alert to save when code is editing
      dispatch(setIsDocumentClicked());
      return;
    }

    if (isBottomDrawerOpen) dispatch(toggleBottomDrawer());

    // dispatch(setFocusElement({ id: null, type: 'transaction', name: "Create Transaction", action: 'create' }));
    // if (rightDrawerStatus == false) dispatch(toggleRightDrawer());
    setOpenAddTransactionDialog(true);
  };

  const onChangeTransaction = (transactionId) => {
    if (codeEditStatus) {
      // For alert to save when code is editing
      dispatch(setIsDocumentClicked());
      return;
    }

    if (entityId !== transactionId) {

      if (isBottomDrawerOpen) dispatch(toggleBottomDrawer());
      if (rightDrawerStatus === true) dispatch(toggleRightDrawer());
      dispatch(setTabOnFocus(0));

      if (currentTag !== 'transaction') {
        history.push(`/blueprint/${slug}/${id}/transaction/${transactionId}`);
      } else {
        history.push(`/blueprint/${slug}/${id}/transaction/${transactionId}`);
      }
      dispatch(setSelectedTransactionId(transactionId));
      dispatch(reRenderInfoBuilder());

    }
  };

  const onEdit = ({ item }) => {
    dispatch(
      setFocusElement({
        id: item._id,
        type: constructIds.find((x) => x._id === item.type).name,
        category: 'editNormal', //for distinguish the edit form in right drawer
      }),
    );
    if (rightDrawerStatus == false) dispatch(toggleRightDrawer());
    //history.push(`/blueprint/${bpName}/information_flow`);
  };

  const createView = () => {
    if (codeEditStatus) {
      // For alert to save when code is editing
      dispatch(setIsDocumentClicked());
      return;
    }

    setViewDialog(true)

  };

  const createUtilityFunction = () => {
    setOpenUtilityFunctionDialog(true);
  }


  // handling selecting views from the list
  const onChangeViews = (viewId) => {
    if (codeEditStatus) {
      // For alert to save when code is editing
      dispatch(setIsDocumentClicked());
      return;
    }

    if (isBottomDrawerOpen) dispatch(toggleBottomDrawer());

    // to close the rightdrawer while switching the view
    if (rightDrawerStatus && entityId !== viewId) {
      dispatch(toggleRightDrawer());
    }

    setSelectedView(viewId);
    dispatch(setCurrentViewId(viewId));
    const segments = window.location.pathname.split('/');
    history.push(`/blueprint/${segments[2]}/${segments[3]}/view/${viewId}`);
    // dispatch(setTabOnFocus(0));
  };

  const onChangeTestsuite = (testsuite) => {
    if (codeEditStatus) {
      // For alert to save when code is editing
      dispatch(setIsDocumentClicked());
      return;
    }


    setSelectedTestsuite(testsuite);
    closeTestsuiteMenu();

    if (entityId !== testsuite._id && rightDrawerStatus) {
      dispatch(toggleRightDrawer());
      dispatch(setTabOnFocus(0));
    }


    const segments = window.location.pathname.split('/');
    if (testsuite.testcase != null) {
      history.push(`/blueprint/${segments[2]}/${segments[3]}/testsuite/${testsuite._id}?testcase=${testsuite.testcase._id}`);
    } else {
      history.push(`/blueprint/${segments[2]}/${segments[3]}/testsuite/${testsuite._id}`);
    }
  };

  const createTestsuite = () => {
    if (codeEditStatus) {
      // For alert to save when code is editing
      dispatch(setIsDocumentClicked());
      return;
    }

    if (isBottomDrawerOpen) dispatch(toggleBottomDrawer());

    dispatch(setFocusElement({ id: null, type: 'testsuite', action: 'create' }));
    if (rightDrawerStatus === false) dispatch(toggleRightDrawer());
    dispatch(setTabOnFocus(0));

  };

  const onChangeDelegate = (obj) => {

    if (codeEditStatus) {
      // For alert to save when code is editing
      dispatch(setIsDocumentClicked());
      return;
    }

    setSelectedDelegate(obj._id);
    dispatch(setNodeClicked({ id: obj._id }));


    if (elementOnFocus && elementOnFocus?.transaction && screen === "transaction") {
      dispatch(setFocusElement({ transaction: elementOnFocus?.transaction, id: obj._id, type: 'external_function', templateId: '', name: obj?.name, protocol: obj?.attributes?.type, icon: obj?.icon, desc: obj?.attributes?.desc, provenance: obj?.provenance }));
    } else {
      dispatch(setFocusElement({ id: obj._id, type: 'external_function', templateId: '', name: obj?.name, protocol: obj?.attributes?.type, icon: obj?.icon, desc: obj?.attributes?.desc, provenance: obj?.provenance }));
      if (!rightDrawerStatus) dispatch(toggleRightDrawer());
    }
    dispatch(setTabOnFocus(0));
  };

  const onChangeClusterlet = (obj) => {
    if (codeEditStatus) {
      // For alert to save when code is editing
      dispatch(setIsDocumentClicked());
      return;
    }

    let type = '';
    if (obj.type === 2) {
      type = 'clusterlet';
    } else if (obj.type === 3) {
      type = 'analytics';
    }


    setSelectedClusterlet(obj._id);
    dispatch(setNodeClicked({ id: obj._id }));

    if (elementOnFocus && elementOnFocus?.transaction && screen == "transaction") {
      dispatch(setFocusElement({ transaction: elementOnFocus?.transaction, id: obj._id, type: type, templateId: '', name: obj?.name, icon: obj?.icon, desc: obj?.attributes?.desc, provenance: obj?.provenance }));
    } else {
      dispatch(setFocusElement({ id: obj._id, type: type, templateId: '', name: obj?.name, icon: obj?.icon, desc: obj?.attributes?.desc, provenance: obj?.provenance }));
      if (rightDrawerStatus === false) dispatch(toggleRightDrawer());
    }
    dispatch(setTabOnFocus(0));
  };

  const onChangeUtilityFunction = (obj) => {
    setOpenUtilityFunctionDialog(true);
    setSelectedUtilityFunction(obj);
  }


  const onClusterletConfigCompletion = () => {
    dispatch(handleSnackBar({ open: true, message: 'View clusterlet configuration updated', severity: 'success' }));
    handleCloseClusterletConfig();
  };

  const trimString = (str, maxLength) => {
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + '..';
    }
    return str;
  };

  const onViewDragEnd = (result) => {
    // Check if the item was dropped outside the list
    if (!result.destination) {
      return;
    }
    setLoading(true);
    // Reorder the items
    const reorderedItems = Array.from(views);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    const arrayWithOrder = reorderedItems.map((obj, index) => ({
      _id: obj._id,
      order: index,
    }));

    setViews(reorderedItems);
    dispatch(invokePostService('reorderView', { arrayWithOrder }, []))
      .then(async (newViews) => {
        if (newViews.status == true) {
          setViews(newViews?.data.sort((a, b) => a.order - b.order));
          dispatch(handleSnackBar({ open: true, message: 'Views reordered', severity: 'success' }));
        } else {
          dispatch(handleSnackBar({ open: true, message: newViews?.message, severity: 'error' }));
        }
        setLoading(false);
      })
      .catch((error) => console.error(error));
  };



  const onTransactionDragEnd = (result) => {
    // Check if the item was dropped outside the list
    if (!result.destination) {
      return;
    }
    // Reorder the items
    const reorderedItems = Array.from(transactionList);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    const arrayWithOrder = reorderedItems.map((obj, index) => ({
      _id: obj._id,
      order: index,
    }));

    setTransactionList(reorderedItems);
    dispatch(invokePostService('reorderTransaction', { arrayWithOrder }, []))
      .then(async (response) => {
        if (response.status == true) {
          setTransactionList(response?.data.sort((a, b) => a.order - b.order));
          dispatch(handleSnackBar({ open: true, message: 'Transaction reordered', severity: 'success' }));
        } else {
          dispatch(handleSnackBar({ open: true, message: response?.message, severity: 'error' }));
        }
      })
      .catch((error) => console.error(error));
  }

  const onClusterletDragEnd = (result) => {
    // Check if the item was dropped outside the list
    if (!result.destination) {
      return;
    }
    // Reorder the items
    const reorderedItems = Array.from(clusterlets);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    const arrayWithOrder = reorderedItems.map((obj, index) => ({
      _id: obj._id,
      order: index,
    }));

    setClusterlets(reorderedItems);
    dispatch(invokePostService('reorderClusterlet', { arrayWithOrder }, []))
      .then(async (response) => {
        if (response.status === true) {
          setClusterlets(response?.data.sort((a, b) => a.order - b.order));
          dispatch(handleSnackBar({ open: true, message: 'Clusterlet reordered', severity: 'success' }));
        } else {
          dispatch(handleSnackBar({ open: true, message: response?.message, severity: 'error' }));
        }
      })
      .catch((error) => console.error(error));

  }

  const onUtilityFunctionDragEnd = (result) => {
    // Check if the item was dropped outside the list
    if (!result.destination) {
      return;
    }
    const reorderedItems = JSON.parse(JSON.stringify(utilityFunctions));
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    const arrayWithOrder = reorderedItems.map((obj, index) => ({
      _id: obj._id,
      order: index,
    }));
    setUtilityFunctions(reorderedItems);
    dispatch(invokePostService('reorderUtilityFunction', { arrayWithOrder }, []))
      .then(async (response) => {
        if (response.status === true) {
          dispatch(handleSnackBar({ open: true, message: 'Utility Functions reordered', severity: 'success' }));
        } else {
          setUtilityFunctions(utilityFunctions);
          dispatch(handleSnackBar({ open: true, message: response?.message, severity: 'error' }));
        }
      })
      .catch((error) => console.error(error));
  }

  const onDelegateDragEnd = (result) => {
    // Check if the item was dropped outside the list
    if (!result.destination) {
      return;
    }
    // Reorder the items
    const reorderedItems = Array.from(delegates);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    const arrayWithOrder = reorderedItems.map((obj, index) => ({
      _id: obj._id,
      order: index,
    }));

    setDelegates(reorderedItems);
    dispatch(invokePostService('reorderDelegate', { arrayWithOrder }, []))
      .then(async (response) => {
        if (response.status === true) {
          setDelegates(response?.data.sort((a, b) => a.order - b.order));
          dispatch(handleSnackBar({ open: true, message: 'Delegate reordered', severity: 'success' }));
        } else {
          dispatch(handleSnackBar({ open: true, message: response?.message, severity: 'error' }));
        }
      })
      .catch((error) => console.error(error));
  }

  const onSimulationDragEnd = (result) => {
    // Check if the item was dropped outside the list
    if (!result.destination) {
      return;
    }
    // Reorder the items
    const reorderedItems = Array.from(testsuites);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    const arrayWithOrder = reorderedItems.map((obj, index) => ({
      _id: obj._id,
      order: index,
    }));

    setTestsuites(reorderedItems);
    dispatch(invokePostService('reorderTestSuite', { arrayWithOrder }, []))
      .then(async (response) => {
        if (response.status === true) {
          setTestsuites(response?.data.sort((a, b) => a.order - b.order));
          dispatch(handleSnackBar({ open: true, message: 'Testsuite reordered', severity: 'success' }));
        } else {
          dispatch(handleSnackBar({ open: true, message: response?.message, severity: 'error' }));
        }
      })
      .catch((error) => console.error(error));
  }

  const toggleCollpase = (type) => {
    if (type === 'transaction') {
      setCollpaseTransaction(!collapseTransaction);
      setCollpaseView(true);
      setCollapseClusterlets(true);
      setCollapseDelegates(true);
      setCollapseSimulations(true);
      setCollapseUtilityFunctions(true);
    } else if (type === 'delegate') {
      setCollapseDelegates(!collapseDelegates);
      setCollpaseView(true);
      setCollapseClusterlets(true);
      setCollpaseTransaction(true);
      setCollapseSimulations(true);
      setCollapseUtilityFunctions(true);
    } else if (type === 'clusterlet') {
      setCollapseClusterlets(!collapseClusterlets);
      setCollapseDelegates(true);
      setCollpaseView(true);
      setCollpaseTransaction(true);
      setCollapseSimulations(true);
      setCollapseUtilityFunctions(true);
    } else if (type === 'simulation') {
      setCollapseSimulations(!collapseSimulations);
      setCollapseDelegates(true);
      setCollpaseView(true);
      setCollpaseTransaction(true);
      setCollapseClusterlets(true);
      setCollapseUtilityFunctions(true);
    } else if (type === 'view') {
      setCollpaseView(!collapseView);
      setCollpaseTransaction(true);
      setCollapseClusterlets(true);
      setCollapseDelegates(true);
      setCollapseSimulations(true);
      setCollapseUtilityFunctions(true);
    } else {
      setCollapseUtilityFunctions(!collapseUtilityFunctions);
      setCollpaseView(true);
      setCollpaseTransaction(true);
      setCollapseClusterlets(true);
      setCollapseDelegates(true);
      setCollapseSimulations(true);
    }
  };

  const toggleTestsuiteOptions = (event, testsuite, index) => {

    setSelectedTestsuite(testsuite);
    setAnchorEl(event.target);
    setTestsuiteActiveMenu(index)
  };

  const testsuiteOptions = [
    { id: "edit", title: "Edit" },
    { id: "configure_context", title: 'Context' },
    { id: "configure_profile", title: 'Profile' },
    { id: 'paste', title: 'Paste' },
    { id: 'delete', title: 'Delete' },
  ]
  const renderTestsuiteOptions = testsuiteOptions.filter(option => testcaseToCopy || option.id !== 'paste')

  const closeTestsuiteMenu = () => {
    setTestsuiteActiveMenu(false);
  };

  const handleShowTooltip = (key) => {
    setTooltipActive(key);
  };

  const handleTestsuiteOptionsOnclick = (event, action, item) => {
    if (codeEditStatus) {
      // For alert to save when code is editing
      dispatch(setIsDocumentClicked());
      return;
    }

    setSelectedTestsuite(item);
    setTestsuiteActiveMenu(null);

    if (action === "delete") {
      setShowDeleteTestsuite(true)
      return;
    }

    if (action === "paste") {
      handleTestcasePaste({ testsuite: item })
      return;
    }


    dispatch(setFocusElement({ id: item._id, name: item.name, description: item.description, type: 'testsuite', action: action }));
    if (action === "edit") {
      dispatch(setTabOnFocus(0));
    } else if (action === "configure_context") {
      dispatch(setTabOnFocus(1));
    } else if (action === "configure_profile") {
      dispatch(setTabOnFocus(2));
    }
    if (rightDrawerStatus === false) dispatch(toggleRightDrawer());

  }

  const handleTestcasePaste = ({ testsuite }) => {
    const testcase = testcases.find(item => item._id === testcaseToCopy?.id);
    const newTestcaseName = prepareNameForCopyingTestcase({ testcase, testsuite });

    const payload = {
      name: newTestcaseName,
      testcase_id: testcaseToCopy.id,
      testsuite_id: testsuite._id
    }
    dispatch(invokePostService('pasteTestcase', payload, [testsuite._id])).then(response => {
      dispatch(setTestcaseToCopy(null));
      if (response.status && response.data !== null) {
        dispatch(handleSnackBar({ open: true, message: response?.message, severity: 'success' }));
        const testcaseDetails = response.data.testcase;
        const { slug, blueprintId } = getDetailsFromUrl();
        history.push(`/blueprint/${slug}/${blueprintId}/testsuite/${testcaseDetails?.testsuite_id}?testcase=${testcaseDetails?._id}`);
        dispatch(setReRender());
      } else {
        if (response?.message) {
          dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
        } else {
          if (response?.errors.length > 0) {
            dispatch(handleSnackBar({ open: true, message: response?.errors[0], severity: 'error' }))
          }
        }
      }

    });
  }

  const prepareNameForCopyingTestcase = ({ testcase, testsuite }) => {
    try {
      const testcaseNamesList = testcases.map(item => {
        if (item.testsuite_id === testsuite._id) {
          return item.name;
        }
      });

      if (!testcaseNamesList.includes(testcase.name)) {
        return testcase.name
      } else {
        return getNewNameForTestcase({ name: `${testcase.name}_copy`, testcaseNamesList });
      }

    } catch (error) {
      console.error(error);
      return null;
    }
  }

  function getNewNameForTestcase({ name, testcaseNamesList }) {
    let newName = name;
    let counter = 2;

    // Loop to check if the new name already exists in the list
    while (testcaseNamesList.includes(newName)) {
      newName = `${name}${counter}`;
      counter++;
    }
    return newName;
  }


  const closeDeleteTestsute = () => {
    setShowDeleteTestsuite(false);
  }


  const generateEntityTooltip = (entity) => {
    const status = getOwnershipStatus(entity.provenance);
    const name = entity.name;
    if (status === "AI_GENERATED"){
      return `${name} - AI Generated`;
    } else if (status === "AI_UPDATED") {
      return `${name} - AI Updated`
    }

    return name;
  }


  return (
    <>

      <div className={classes.root}>
        {openClusterletConfig && <ClusterletsConfiguration onClose={handleCloseClusterletConfig} onCompletion={onClusterletConfigCompletion} />}
        {openAddTransactionDialog && <TransactionDialog onClose={() => setOpenAddTransactionDialog(false)} />}
        {
          openViewsDialog &&
          <TransactionDialog onClose={() => setViewDialog(false)} title="Add View">
            <ViewForm onClose={() => setViewDialog(false)} action="create" />
          </TransactionDialog>
        }

        {drawerOpen && (
          <Box
            id="close_sidebar_btn"
            onClick={toggleSideDrawer}
            style={{
              position: 'fixed',
              top: '50%',
              left: '235px', // 64px fixed drawer + 171px sidebar = 235px
              transform: 'translateY(-50%)',
              zIndex: 1300,
              background: '#2f3e55',
              color: '#fff',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 0 4px rgba(0,0,0,0.4)',
            }}
          >
            <ChevronLeftIcon />
          </Box>
        )}

        <Drawer
          className={drawerOpen ? classes.drawer : classes.collapseMainDrawer}
          variant="persistent"
          anchor="left"
          open={drawerOpen}
          classes={{
            paper: classes.drawerPaper,
          }}>
          {/* <Box color="primary" aria-label="add" className={classes.expandIcon} onClick={toggleSideDrawer} id="close_sidebar_btn">
            <ChevronLeftIcon fontSize={'small'} />
          </Box> */}


          <Grid container direction="column" style={{ marginTop: 67, height: '100vh', color: '#fff' }} id="sidebarListContainer" className={classes.sidebarListContainer}>
            <Grid item xs className={`${classes.sidebarTopContent} ${collapseView && classes.listCollapsed}`}>
              <div style={{ zIndex: 19, position: 'fixed', width: '171px', display: 'flex', justifyContent: 'space-between' }} className={classes.listHeader}>
                <Typography style={{ float: 'left', marginLeft: 10 }} variant="body2" className={classes.myTopography}>
                  Views
                </Typography>

                <div style={{ display: 'flex', justifyContent: 'flex-end', 'align-items': 'center', marginRight: '5px' }}>
                  <Tooltip title="Create View">
                    <AddIcon onClick={createView} id="create_view" className={classes.listHeaderIcon} style={{ marginRight: '5px' }} data-ui-tour-id='sb-add-view-btn' />
                  </Tooltip>

                  <Tooltip title={collapseView ? 'Expand View' : 'Collapse View'}>
                    {collapseView ? <ExpandMoreIcon className={classes.listHeaderIcon} onClick={() => toggleCollpase('view')} id="collapse_view" /> : <ExpandLessIcon className={classes.listHeaderIcon} onClick={() => toggleCollpase('view')} id="collapse_view" />}
                  </Tooltip>
                </div>
              </div>

              {views.length == 0 && !collapseView && (
                <Grid item xs style={{ marginTop: '48px', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
                  <Typography fontFamily="Arial" style={{ float: 'right', marginLeft: 10 }}>
                    No views
                  </Typography>
                </Grid>
              )}

              {views.length > 0 && !collapseView && (
                <Grid item xs style={{ marginTop: '30px' }}>
                  <DragDropContext onDragEnd={onViewDragEnd}>
                    <Droppable droppableId="items">
                      {(provided) => (
                        <List id="view_list" {...provided.droppableProps} ref={provided.innerRef} className={classes.listItemsContainer}>
                          {views.map((view, index) => (
                            <Draggable key={view._id} draggableId={view._id} index={index}>
                              {(provided) => (
                                <Tooltip title={generateEntityTooltip(view)}>
                                  <ListItem
                                    id={`list_item_${view.name}`}
                                    button
                                    onClick={() => onChangeViews(view._id)}
                                    selected={entityId == view._id && currentTag == 'view'}
                                    style={{ marginTop: 'auto', flex: 1, background: selectedIndex == 5 ? '#ffff00' : '', justifyContent: 'center' }}
                                    className={classes.myListItem}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    ref={provided.innerRef}>
                           
                                    <Typography noWrap style={{ padding: '5px 0', width: '100%' }}>
                                      {view.name}
                                    </Typography>
                                    {/* <ListItemText primary={trimString(view.name, maxStringLength)} /> */}
                                  </ListItem>
                                </Tooltip>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </List>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Grid>
              )}
            </Grid>

            <Grid item xs className={`${classes.sidebarTopContent} ${collapseTransaction && classes.listCollapsed}`}>
              <div style={{ zIndex: 19, position: 'fixed', width: '171px', display: 'flex', justifyContent: 'space-between' }} className={classes.listHeader}>
                <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }} variant="body2" className={classes.myTopography}>
                  Transactions
                </Typography>

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '5px' }}>
                  <Tooltip title="Create Transaction">
                    <AddIcon className={classes.listHeaderIcon} onClick={createTransaction} id="create_transaction" style={{ marginRight: '5px' }} data-ui-tour-id='sb-add-transaction-btn' />
                  </Tooltip>

                  <Tooltip classes={{ tooltip: `${tooltipActive ? classes.tooltipActive : classes.tooltipInactive}` }} open={tooltipActive === 'transaction'} title={collapseTransaction ? 'Expand Transaction' : 'Collapse Transaction'}>
                    {collapseTransaction ? (
                      <ExpandMoreIcon onMouseEnter={() => handleShowTooltip('transaction')} onMouseLeave={() => handleShowTooltip('')} onMouseDown={() => handleShowTooltip('')} className={classes.listHeaderIcon} onClick={() => toggleCollpase('transaction')} id="collapse_transaction" />
                    ) : (
                      <ExpandLessIcon onMouseEnter={() => handleShowTooltip('transaction')} onMouseLeave={() => handleShowTooltip('')} onMouseDown={() => handleShowTooltip('')} className={classes.listHeaderIcon} onClick={() => toggleCollpase('transaction')} id="collapse_transaction" />
                    )}
                  </Tooltip>
                </div>
              </div>

              {transactionList.length == 0 && !collapseTransaction && (
                <Grid item xs style={{ marginTop: '48px', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
                  <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }}>
                    No transactions
                  </Typography>
                </Grid>
              )}

              {transactionList.length > 0 && !collapseTransaction && (
                <Grid item xs style={{ marginTop: '30px' }}>
                  <DragDropContext onDragEnd={onTransactionDragEnd}>
                    <Droppable droppableId="items">
                      {(provided) => (
                        <List id="transaction_list" {...provided.droppableProps} ref={provided.innerRef} className={classes.listItemsContainer}>
                          {transactionList.map((tr, index) => (
                            <Draggable key={tr._id} draggableId={tr._id} index={index}>
                              {(provided) => (
                                <Tooltip title={generateEntityTooltip(tr)}>
                                  <ListItem
                                    button
                                    onClick={() => onChangeTransaction(tr._id)}
                                    selected={selectedId == tr._id && currentTag == 'transaction'}
                                    style={{ marginTop: 'auto', flex: 1, background: selectedIndex == 5 ? '#ffff00' : '', justifyContent: 'center' }}
                                    className={`${classes.myListItem} transaction_${tr.name}`}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    ref={provided.innerRef}
                                  >
                                    <Typography noWrap style={{ padding: '5px 0', width: '100%' }}>
                                      {tr.name}
                                    </Typography>
                                  </ListItem>
                                </Tooltip>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </List>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Grid>
              )}
            </Grid>

            <Grid item xs className={`${classes.sidebarTopContent} ${collapseClusterlets && classes.listCollapsed}`}>
              <div style={{ zIndex: 19, position: 'fixed', width: '171px', display: 'flex', justifyContent: 'space-between' }} className={classes.listHeader}>
                <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }} variant="body2" className={classes.myTopography}>
                  Clusterlets
                </Typography>

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '5px' }}>
                  <Tooltip classes={{ tooltip: `${tooltipActive ? classes.tooltipActive : classes.tooltipInactive}` }} open={tooltipActive === 'clusterlets'} title={collapseClusterlets ? 'Expand Clusterlets' : 'Collapse Clusterlets'}>
                    {collapseClusterlets ? (
                      <ExpandMoreIcon onMouseEnter={() => handleShowTooltip('clusterlets')} onMouseLeave={() => handleShowTooltip('')} onMouseDown={() => handleShowTooltip('')} className={classes.listHeaderIcon} onClick={() => toggleCollpase('clusterlet')} id="collapse_clusterlet" />
                    ) : (
                      <ExpandLessIcon onMouseEnter={() => handleShowTooltip('clusterlets')} onMouseLeave={() => handleShowTooltip('')} onMouseDown={() => handleShowTooltip('')} className={classes.listHeaderIcon} onClick={() => toggleCollpase('clusterlet')} id="collapse_clusterlet" />
                    )}
                  </Tooltip>
                </div>
              </div>

              {clusterlets.length == 0 && !collapseClusterlets && (
                <Grid item xs style={{ marginTop: '48px', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
                  <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }}>
                    No clusterlets
                  </Typography>
                </Grid>
              )}

              {clusterlets.length > 0 && !collapseClusterlets && (
                <Grid item xs style={{ marginTop: '30px' }}>
                  <DragDropContext onDragEnd={onClusterletDragEnd}>
                    <Droppable droppableId="items">
                      {(provided) => (
                        <List id="clusterlets_list" {...provided.droppableProps} ref={provided.innerRef} className={classes.listItemsContainer}>
                          {clusterlets.map((item, index) => (
                            <Draggable key={item._id} draggableId={item._id} index={index}>
                              {(provided) => (
                                <Tooltip title={generateEntityTooltip(item)} key={item._id}>
                                  <ListItem
                                    button
                                    onClick={() => onChangeClusterlet(item)}
                                    selected={item._id === selectedClusterlet}
                                    style={{ marginTop: 'auto', flex: 1, background: selectedIndex == 5 ? '#ffff00' : '', justifyContent: 'center' }}
                                    className={classes.myListItem}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    ref={provided.innerRef}
                                  >
                                    <Typography noWrap style={{ padding: '5px 0', width: '100%' }}>
                                      {item.name}
                                    </Typography>
                                  </ListItem>
                                </Tooltip>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </List>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Grid>
              )}
            </Grid>

            <Grid item xs className={`${classes.sidebarTopContent} ${collapseDelegates && classes.listCollapsed}`}>
              <div style={{ zIndex: 19, position: 'fixed', width: '171px', display: 'flex', justifyContent: 'space-between' }} className={classes.listHeader}>
                <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }} variant="body2" className={classes.myTopography}>
                  Delegates
                </Typography>

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '5px' }}>
                  <Tooltip classes={{ tooltip: `${tooltipActive ? classes.tooltipActive : classes.tooltipInactive}` }} open={tooltipActive === 'delegate'} title={collapseDelegates ? 'Expand Delegates' : 'Collapse Delegates'}>
                    {collapseDelegates ? (
                      <ExpandMoreIcon onMouseEnter={() => handleShowTooltip('delegate')} onMouseLeave={() => handleShowTooltip('')} className={classes.listHeaderIcon} onMouseDown={() => handleShowTooltip('')} onClick={() => toggleCollpase('delegate')} id="collapse_delegate" />
                    ) : (
                      <ExpandLessIcon onMouseEnter={() => handleShowTooltip('delegate')} onMouseLeave={() => handleShowTooltip('')} className={classes.listHeaderIcon} onMouseDown={() => handleShowTooltip('')} onClick={() => toggleCollpase('delegate')} id="collapse_delegate" />
                    )}
                  </Tooltip>
                </div>
              </div>

              {delegates.length == 0 && !collapseDelegates && (
                <Grid item xs style={{ marginTop: '48px', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
                  <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }}>
                    No delegates
                  </Typography>
                </Grid>
              )}

              {delegates.length > 0 && !collapseDelegates && (
                <Grid item xs style={{ marginTop: '30px' }}>
                  <DragDropContext onDragEnd={onDelegateDragEnd}>
                    <Droppable droppableId="items">
                      {(provided) => (
                        <List id="delegates_list" {...provided.droppableProps} ref={provided.innerRef} className={classes.listItemsContainer}>
                          {delegates.map((item, index) => (
                            <Draggable key={item._id} draggableId={item._id} index={index}>
                              {(provided) => (
                                <Tooltip title={generateEntityTooltip(item)} key={item._id}>
                                  <ListItem
                                    button
                                    onClick={() => onChangeDelegate(item)}
                                    selected={item._id === selectedDelegate}
                                    style={{ marginTop: 'auto', flex: 1, background: selectedIndex == 5 ? '#ffff00' : '', justifyContent: 'center' }}
                                    className={classes.myListItem}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    ref={provided.innerRef}
                                  >
                                    <Typography noWrap style={{ padding: '5px 0', width: '100%' }}>
                                      {item.name}
                                    </Typography>
                                  </ListItem>
                                </Tooltip>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </List>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Grid>
              )}
            </Grid>

            <Grid item xs className={`${classes.sidebarTopContent} ${collapseUtilityFunctions && classes.listCollapsed}`}>
              <div style={{ zIndex: 19, position: 'fixed', width: '171px', display: 'flex', justifyContent: 'space-between' }} className={classes.listHeader}>
                <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }} variant="body2" className={classes.myTopography}>
                  Utility Functions
                </Typography>

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '5px' }}>
                  <Tooltip title="Create Utility Function">
                    <AddIcon onClick={createUtilityFunction} id="create_utility_function" className={classes.listHeaderIcon} style={{ marginRight: '5px' }} data-ui-tour-id='sb-add-utilityFunction-btn' />
                  </Tooltip>
                  <Tooltip classes={{ tooltip: `${tooltipActive ? classes.tooltipActive : classes.tooltipInactive}` }} open={tooltipActive === 'utilityFunctions'} title={collapseUtilityFunctions ? 'Expand Utility Functions' : 'Collapse Utility Functions'}>
                    {collapseUtilityFunctions ? (
                      <ExpandMoreIcon onMouseEnter={() => handleShowTooltip('utilityFunctions')} onMouseLeave={() => handleShowTooltip('')} onMouseDown={() => handleShowTooltip('')} className={classes.listHeaderIcon} onClick={() => toggleCollpase('utilityFunctions')} id="collapse_utilityFunctions" />
                    ) : (
                      <ExpandLessIcon onMouseEnter={() => handleShowTooltip('utilityFunctions')} onMouseLeave={() => handleShowTooltip('')} onMouseDown={() => handleShowTooltip('')} className={classes.listHeaderIcon} onClick={() => toggleCollpase('utilityFunctions')} id="collapse_utilityFunctions" />
                    )}
                  </Tooltip>
                </div>
              </div>

              {utilityFunctions.length == 0 && !collapseUtilityFunctions && (
                <Grid item xs style={{ marginTop: '48px', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
                  <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }}>
                    No utility functions
                  </Typography>
                </Grid>
              )}

              {utilityFunctions.length > 0 && !collapseUtilityFunctions && (
                <Grid item xs style={{ marginTop: '30px' }}>
                  <DragDropContext onDragEnd={onUtilityFunctionDragEnd}>
                    <Droppable droppableId="items">
                      {(provided) => (
                        <List id="utilityFunctions_list" {...provided.droppableProps} ref={provided.innerRef} className={classes.listItemsContainer}>
                          {utilityFunctions.map((item, index) => (
                            <Draggable key={item._id} draggableId={item._id} index={index}>
                              {(provided) => (
                                <Tooltip title={generateEntityTooltip(item)} key={item._id}>
                                  <ListItem
                                    button
                                    onClick={() => onChangeUtilityFunction(item)}
                                    selected={item._id === selectedUtilityFunction?._id}
                                    style={{ marginTop: 'auto', flex: 1, background: selectedIndex == 5 ? '#ffff00' : '', justifyContent: 'center' }}
                                    className={classes.myListItem}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    ref={provided.innerRef}
                                  >
                                    <Typography noWrap style={{ padding: '5px 0', width: '100%' }}>
                                      {item.name}
                                    </Typography>
                                  </ListItem>
                                </Tooltip>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </List>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Grid>
              )}
            </Grid>

            <Grid item xs className={`${classes.sidebarTopContent} ${collapseSimulations && classes.listCollapsed}`}>
              <div style={{ zIndex: 19, position: 'fixed', width: '171px', display: 'flex', justifyContent: 'space-between' }} className={classes.listHeader}>
                <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }} variant="body2" className={classes.myTopography}>
                  Simulations
                </Typography>

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '5px' }}>
                  <Tooltip title="Create Testsuite">
                    <AddIcon className={classes.listHeaderIcon} onClick={createTestsuite} id="create_testsuite" style={{ marginRight: '5px' }} data-ui-tour-id='sb-add-simulation-btn' />
                  </Tooltip>
                  <Tooltip classes={{ tooltip: `${tooltipActive ? classes.tooltipActive : classes.tooltipInactive}` }} open={tooltipActive === 'simulation'} title={collapseSimulations ? 'Expand Simulations' : 'Collapse Simulations'}>
                    {collapseSimulations ? (
                      <ExpandMoreIcon onMouseEnter={() => handleShowTooltip('simulation')} onMouseLeave={() => handleShowTooltip('')} className={classes.listHeaderIcon} onMouseDown={() => handleShowTooltip('')} onClick={() => toggleCollpase('simulation')} id="expand_simulation" />
                    ) : (
                      <ExpandLessIcon onMouseEnter={() => handleShowTooltip('simulation')} onMouseLeave={() => handleShowTooltip('')} className={classes.listHeaderIcon} onMouseDown={() => handleShowTooltip('')} onClick={() => toggleCollpase('simulation')} id="collapse_simulation" />
                    )}
                  </Tooltip>
                </div>
              </div>

              {testsuites.length == 0 && (
                <Grid item xs style={{ marginTop: '48px', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
                  <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }}>
                    No testsuites
                  </Typography>
                </Grid>
              )}

              {testsuites.length > 0 && !collapseSimulations && (
                <Grid item xs style={{ marginTop: '30px' }}>
                  <DragDropContext onDragEnd={onSimulationDragEnd}>
                    <Droppable droppableId="items">
                      {(provided) => (
                        <List id="testsuites_list" {...provided.droppableProps} ref={provided.innerRef} className={classes.listItemsContainer}>
                          {testsuites.map((testsuite, index) => (
                            <Draggable key={testsuite._id} draggableId={testsuite._id} index={index}>
                              {(provided) => (
                                <Tooltip title={generateEntityTooltip(testsuite)} key={index}>
                                  <ListItem
                                    selected={testsuite._id === entityId}
                                    button
                                    id={`testsuite_${testsuite.name}_item`}
                                    style={{ marginTop: 'auto', flex: 1, justifyContent: 'center' }}
                                    className={classes.myListItem}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    ref={provided.innerRef}
                                  >
                                    
                                    <Typography onClick={() => onChangeTestsuite(testsuite)} noWrap style={{ padding: '5px 0', width: '100%' }}>{testsuite.name}</Typography>

                                    <MoreVertIcon
                                      id={"showOptions"}
                                      onClick={(event) => toggleTestsuiteOptions(event, testsuite, index)}
                                      fontSize="5rem"
                                      style={{
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                      }}
                                    />
                                    <Menu
                                      keepMounted
                                      id={`testsuiteMenu_${testsuite.name}`}
                                      open={testsuiteActiveMenu === index}
                                      anchorEl={anchorEl}
                                      onClose={closeTestsuiteMenu}
                                      PaperProps={{
                                        style: {
                                          maxHeight: '100%',
                                          width: '20ch',
                                        },
                                      }}
                                    >
                                      {renderTestsuiteOptions.map((option, index) => (
                                        <MenuItem key={index} className={classes.testsuiteMenuItem} onClick={(event) => handleTestsuiteOptionsOnclick(event, option.id, testsuite)}>
                                          <Typography noWrap id={option.id}>
                                            {option.title}
                                          </Typography>
                                        </MenuItem>

                                      ))}
                                    </Menu>
                                  </ListItem>
                                </Tooltip>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </List>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* (selectedTestsuite && ) */}

        </Drawer>
      </div>

      {showDeleteTestsuite && <DeleteSimulationTestsuiteAlert onClose={closeDeleteTestsute} element={selectedTestsuite} />}
      {openUtilityFunctionDialog && <UtilityFunctionDialog handleClose={handleCloseUtilityFunctonDialog} setSelectedUtilityFunction={setSelectedUtilityFunction} selectedUtilityFunction={selectedUtilityFunction} />}

    </>
  );
}
